import { config } from 'config';
import { GeneralApiTagTypes } from 'core/api';

import { TMailInvoiceRequestBody, TMailInvoiceResponseBody } from '../types';
import { invoicingApi } from '.';

const extendedApi = invoicingApi.injectEndpoints({
    endpoints: (builder) => ({
        mailInvoice: builder.mutation<TMailInvoiceResponseBody, TMailInvoiceRequestBody>({
            query: ({ invoiceId, ...rest }) => ({
                url: config.api.endpoints.invoiceEmail.replace(':invoiceId', String(invoiceId)),
                method: 'POST',
                body: {
                    ...rest,
                },
            }),
            onQueryStarted: async ({ invoiceId }, { dispatch, queryFulfilled, getState }) => {
                const patches: { undo: () => void }[] = [];

                // Update sent status in the invoice detail
                const patchInvoiceDetail = dispatch(
                    invoicingApi.util.updateQueryData('getOneInvoice', { id: String(invoiceId) }, (draft) => {
                        draft.invoiceSent = true;
                    }),
                );
                patches.push(patchInvoiceDetail);

                // Update sent status in the invoice list
                const queries = invoicingApi.util.selectInvalidatedBy(getState(), [GeneralApiTagTypes.invoice.list]);
                for (const { endpointName, originalArgs } of queries) {
                    if (endpointName !== 'getInvoices') continue;

                    const patch = dispatch(
                        invoicingApi.util.updateQueryData(endpointName, originalArgs, (draft) => {
                            draft.data?.forEach((invoice) => {
                                if (invoice.invoice_id !== invoiceId) return;
                                invoice.invoiceSent = true;
                            });
                        }),
                    );
                    patches.push(patch);
                }

                try {
                    await queryFulfilled;
                } catch (error) {
                    patches.forEach((patch) => patch.undo());
                }
            },
            invalidatesTags: (_res, error, { invoiceId }) =>
                error
                    ? []
                    : [GeneralApiTagTypes.attachment.item, { type: GeneralApiTagTypes.attachment.list, id: invoiceId }],
        }),
    }),
});

export const { useMailInvoiceMutation } = extendedApi;
